<div class=" " *ngIf="showRequest" [class.read-only-content]="isReadOnly">
  <h2 class="sectionTitle" *ngIf="!isReadOnly">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.SALVAGE_REQUEST' | translate }}</h2>

       <!--request Details summary-->
       <app-request-details *ngIf="RequestId" [baseRequest]="baseRequestDTO"></app-request-details>
       <!--request -->

  <form [formGroup]="salvageRequestForm" >
    <div class="form-container">
      <h4 class="section-title">{{ 'FRONT_USER.REQUEST_INFORMATION' | translate }}</h4>

      <div class="form-group">
        <label for="JobTypeSelect">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.JOB_TYPE' | translate }}</label>
        <span class="red"> *</span>
        <ng-multiselect-dropdown id="JobTypeSelect" formControlName ="SelectedJobTypes" [ngModel]="SelectedJobTypes"
          placeholder="{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.CHOOSE_JOB_TYPE' | translate }}" [settings]="dropdownSettings" [data]="JobTypesOptions"
          [disabled]="isReadOnly">
        </ng-multiselect-dropdown>
        <div *ngIf="(submitted||Validate.SelectedJobTypes?.touched) && Validate.SelectedJobTypes?.errors" class="red">
          <div *ngIf="Validate.SelectedJobTypes?.errors?.required">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
      </div>

      <div class="form-group">
        <label for="BriefDescription">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.BRIEF_DESCRIPTION' | translate }}</label>
        <span class="red"> *</span>
        <textarea class="form-control" id="BriefDescription" name="BriefDescription"
          formControlName="BriefDescription"></textarea>
        <div *ngIf="submitted ||( Validate.BriefDescription?.errors&&Validate.BriefDescription?.dirty)" class="red">
          <div *ngIf="Validate.BriefDescription?.errors?.required">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
          <div *ngIf="Validate.BriefDescription?.errors?.maxlength">
            {{'FRONT_USER.REPAIR_REQUEST_FORM.WORK_DESCRIPTION_MAX_LENGTH_ERROR' | translate}}</div>
        </div>
      </div>

      <div class="form-group">
        <label for="ETADate">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.ETA' | translate }}</label>
        <span class="red"> *</span>
        <div class="split-form-group ">
          <input class="form-control" #datepickerMDY="bsDatepicker" bsDatepicker formControlName="ETADate"    [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' , containerClass : 'theme-dark-blue'}">
          <timepicker [hourStep]="1" [minuteStep]="1"  id="ETATime" formControlName="ETATime" ></timepicker>
        </div>
        <div *ngIf="submitted && Validate.ETADate?.errors" class="red">
          <div *ngIf="Validate.ETADate?.errors?.required">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
            <div *ngIf="Validate.ETADate?.errors?.inValidDateError">{{'FRONT_USER.DATE_ERROR' | translate}}
            </div>
        </div>
        <div *ngIf="submitted && Validate.ETATime?.errors" class="red">
          <div *ngIf="Validate.IMONoControl?.ETATime?.required">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>

        </div>

      </div>

      <div class="form-group">
        <label for="IMONo">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.IMO_NO' | translate }}</label>
        <span class="red"> *</span>
        <div class="input-group">
          <span class="input-group-addon">IMO</span>
        <input type="text" class="form-control" id="IMONo" name="IMONo" formControlName="IMONo" />
        </div>
        <div *ngIf="submitted ||( Validate.IMONo?.errors&&Validate.IMONo?.dirty)" class="red ">
          <div *ngIf="Validate.IMONo?.errors?.required">{{ 'FRONT_USER.This_Field_Is_Required' | translate }}
          </div>
          <div *ngIf="Validate.IMONo?.errors?.pattern">{{'FRONT_USER.IMO_ERROR' | translate}}</div>

        </div>
      </div>

      <div class="form-group">
        <label for="AgentName">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.AGENT_NAME' | translate }}</label>
        <span class="red"> *</span>
        <input type="text" class="form-control" id="AgentName" name="AgentName" formControlName="AgentName" />
        <div *ngIf="submitted ||(Validate.AgentName?.errors&&Validate.AgentName?.dirty)" class="red ">
          <div *ngIf="Validate.AgentName?.errors?.required">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
        <div *ngIf="Validate.AgentName?.errors?.maxlength">
          {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.REQUESTOR_TYPE' | translate }}</label>
        <span class="red"> *</span>
        <div class="form-custom-inputs">
          <div *ngFor="let requestor of requestorTypeKey;let i='index'" class="custom-Radio">
            <input [id]="[requestor]" type="radio" name="SalvageRequestorType" [value]="requestorType[requestor]"
              formControlName="SalvageRequestorType" />
            <label [for]="[requestor]">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.' + requestor | translate }}</label>
          </div>
        </div>
        <div *ngIf="submitted && Validate.SalvageRequestorType?.errors" class="red">
          <div *ngIf="Validate.SalvageRequestorType?.errors?.required">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
      </div>

      <div class="form-group">
        <label
          for="ClassificationSocietySelect">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.CLASSIFICATION_SOCIETY' | translate }}</label>
        <span class="red"> *</span>
        <select id="ClassificationSocietySelect" name="ClassificationSocietySelect" class="form-control"
          formControlName="ClassificationSocietyId" (change)="onClassificationChange($event.target.value)">
          <option [value]="undefined" selected>
            {{ 'FRONT_USER.SALVAGE_REQUEST_FORM.CHOOSE_CLASSIFICATION_SOCIETY' | translate }}</option>
          <ng-container *ngFor="let ClassificationSociety of ClassificationSocieties">
            <option *ngIf="displayedLang==Languages.English" [value]="ClassificationSociety.Id">
              {{ ClassificationSociety.NameEN }}</option>
            <option *ngIf="displayedLang==Languages.Arabic" [value]="ClassificationSociety.Id">
              {{ ClassificationSociety.NameAR }}</option>
          </ng-container>
        </select>

        <div *ngIf="(submitted|| Validate.ClassificationSocietyId?.touched) && (Validate.ClassificationSocietyId?.value == 'undefined'|| Validate.ClassificationSocietyId?.errors)" class="red ">
          <div *ngIf="Validate.ClassificationSocietyId?.value == 'undefined'">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
      </div>

      <div class="form-group" *ngIf="Validate.ClassificationSocietyId.value == 17">
        <label
          for="ClassificationSocietyOther">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.CLASSIFICATION_SOCIETY_OTHER' | translate }}</label>
        <span class="red"> *</span>
        <input type="text" class="form-control" id="ClassificationSocietyOther" name="ClassificationSocietyOther"
          formControlName="ClassificationSocietyOther" />

        <div *ngIf="submitted && Validate.ClassificationSocietyOther?.errors" class="red ">
          <div *ngIf="Validate.ClassificationSocietyOther?.errors?.required">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
        <div *ngIf="Validate.ClassificationSocietyOther?.errors?.maxlength">
          {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
        </div>
      </div>

      <div class="form-group">
        <label for="AnchorageAreaSelect">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.ANCHORAGE_AREA' | translate }}</label>
        <span class="red"> *</span>
        <select id="AnchorageAreaSelect" name="AnchorageAreaSelect" class="form-control"
          formControlName="SalvageAnchorageAreaId">
          <option [value]="undefined" selected>{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.CHOOSE_ANCHORAGE_AREA' | translate }}
          </option>
          <ng-container *ngFor="let AnchorageArea of AnchorageAreas">
            <option *ngIf="displayedLang==Languages.English" [value]="AnchorageArea.Id">{{ AnchorageArea.NameEN }}
            </option>
            <option *ngIf="displayedLang==Languages.Arabic" [value]="AnchorageArea.Id">{{ AnchorageArea.NameAR }}
            </option>
          </ng-container>
        </select>

        <div *ngIf="(submitted|| Validate.SalvageAnchorageAreaId?.touched)&& (Validate.SalvageAnchorageAreaId?.value == 'undefined'|| Validate.SalvageAnchorageAreaId?.errors)" class="red ">
          <div *ngIf="Validate.SalvageAnchorageAreaId?.value == 'undefined'">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
      </div>



      <div class="form-group">

        <label>{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.NEAREST_LOCATION' | translate }}</label>
        <span class="red"> *</span>
        <div class="form-custom-inputs">
          <div class="custom-Radio" *ngFor="let location of nearestLocationKey;let i='index'">
            <input [id]="[location]" type="radio" name="NearestLocation" [value]="nearestLocation[location]"
              formControlName="NearestLocation" />
            <label [for]="[location]">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.' + location | translate }}</label>
          </div>
        </div>

        <div *ngIf="submitted && Validate.NearestLocation?.errors" class="red ">
          <div *ngIf="Validate.NearestLocation?.errors?.required">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="ShipParticular">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.SHIP_PARTICULAR' | translate }}</label>
        <textarea type="text" class="form-control" id="ShipParticular" name="ShipParticular"
          formControlName="ShipParticular"></textarea>
        <div class="upload-info">
          <span data-toggle="tooltip"
            title="{{'FRONT_USER.SALVAGE_REQUEST_FORM.SHIP_PARTICULAR' | translate}}">{{'FRONT_USER.SALVAGE_REQUEST_FORM.SHIP_PARTICULAR_INFO' | translate}}</span>
        </div>
        <div *ngIf="submitted ||( Validate.ShipParticular?.errors&& Validate.ShipParticular?.dirty)" class="red">
          <div *ngIf="Validate.ShipParticular?.errors?.maxlength">
            {{'FRONT_USER.REPAIR_REQUEST_FORM.WORK_DESCRIPTION_MAX_LENGTH_ERROR' | translate}}</div>
        </div>
      </div>
    </div>

    <app-user-request-details [UserRequestDetailsformGroup]="salvageRequestForm" [IsReadOnly]="isReadOnly"
      [SubmitFlag]="submitted" [IsFaxOptional]="true" [extrnalData]="userInfo"></app-user-request-details>

    <div class="form-group" *ngIf="!isReadOnly">
      <label for="TermsAndConditions">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.TERMS_CONDITIONS' | translate }}</label>
      <span class="red"> *</span>
      <div class="custom-checkbox">
        <input type="checkbox" id="TermsAndConditions" name="TermsAndConditions"
          formControlName="TermsAndConditionsControl" />
        <label for="TermsAndConditions">
          <a (click)="goToTermsAndConditions()" target="_blank"> {{ 'FRONT_USER.TERMS_CONDITIONS_ACCEPTANCE' | translate }}</a>
        </label>
      </div>
      <div *ngIf="submitted && Validate.TermsAndConditionsControl?.errors" class="red">
        <div *ngIf="Validate.TermsAndConditionsControl?.errors?.required">
          {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
      </div>
    </div>

    <div class="form-group" *ngIf="!isReadOnly">
      <button Confirmation (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate }}</button>
    </div>

  </form>
</div>

<!-- Confirmation -->
<div *ngIf="!showRequest&&!isErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p> {{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}
    </p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>


<!-- error message -->
<div *ngIf="!showRequest&&isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>

  </div>
</div>

<div *ngIf="RequestId">
  <app-messaging></app-messaging>
</div>
